import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import { RouteStore } from '@seedlang/stores';
import routeConfig from './route_config';
import { createReactRouterRoutes, flattenRouteConfig } from 'utils/route_config';
import { NamedRouteContext } from 'utils/named_route_context';
import { resolveNamedRoutePath } from 'utils/route_paths';

export const reactRouterRoutes = createReactRouterRoutes(routeConfig);
export const appRouter = createBrowserRouter(reactRouterRoutes);
export const routeRegistry = flattenRouteConfig(routeConfig);

RouteStore.setPathFor(route => resolveNamedRoutePath(route, routeRegistry.namedRoutes));

export function ReactRouterApp() {
  return (
    <NamedRouteContext.Provider value={routeRegistry.namedRoutes}>
      <RouterProvider router={appRouter} />
    </NamedRouteContext.Provider>
  );
}
